import Components from "slotworks/components/components";
import PromptContent from "slotworks/components/prompt/prompt-content";
import { Services } from "slotworks/services/services";
import State from "slotworks/state-machine/states/state";

export default class MaxFreespins extends State {
    public onEnter() {
        const prompt = new PromptContent(["info"]);
        prompt.setText("body", Services.translations.get("fs.max"));

        Components.prompt.showPrompt(prompt).then(() => this.complete());
    }
}
